import React from 'react';
import { useEstimator } from './context';
import styles from './ProjectEstimator.module.scss';

const STEPS = [
  { num: '01', label: 'SERVICES' },
  { num: '02', label: 'ESTIMATE' },
];

export const ProgressIndicator: React.FC = () => {
  const { step, setStep } = useEstimator();

  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressList}>
        {STEPS.map((s, index) => {
          const stepNum = index + 1;
          const isActive = step === stepNum;
          const isPassed = step > stepNum;

          return (
            <button
              key={s.num}
              type="button"
              className={`${styles.progressItem} ${isActive ? styles.progressActive : ''} ${
                isPassed ? styles.progressPassed : ''
              }`}
              onClick={() => {
                if (isPassed) {
                  setStep(stepNum);
                }
              }}
              disabled={!isPassed && !isActive}
              aria-current={isActive ? 'step' : undefined}
            >
              <span className={styles.stepNum}>{s.num}</span>
              <span className={styles.stepLabel}>{s.label}</span>
              <div className={styles.stepUnderline} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;
